(function () {
  if (window.ucBundleDrawerFixLoaded) return;
  window.ucBundleDrawerFixLoaded = true;

  var PISTOL_BY_COLOR = {
    brown: 41311502499934,
    'dark brown': 41311502565470,
    'khaki canvas': 42316292980830,
    sand: 42316282593374,
    'grey canvas': 42316293177438,
    black: 41311502532702,
    aztec: 42872277499998,
    olive: 42872277467230
  };

  function rootUrl() {
    var root = window.routes && window.routes.root ? window.routes.root : window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function cleanText(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function colorToken(value) {
    var text = cleanText(value);
    if (!text) return '';
    if (/\bdark\s*brown\b|\bdk\s*brown\b|\bdkbrown\b/.test(text)) return 'dark brown';
    if (/\bgrey\s*canvas\b|\bgray\s*canvas\b|\bgrey\b|\bgray\b/.test(text)) return 'grey canvas';
    if (/\bkhaki\s*canvas\b|\bkhaki\b/.test(text)) return 'khaki canvas';
    if (/\baztec\b/.test(text)) return 'aztec';
    if (/\bolive\b/.test(text)) return 'olive';
    if (/\bblack\b/.test(text)) return 'black';
    if (/\bsand\b/.test(text)) return 'sand';
    if (/\bbrown\b/.test(text)) return 'brown';
    return '';
  }

  function colorFromNode(node) {
    if (!node) return '';
    var attrs = ['data-color', 'data-color-name', 'data-value', 'data-option', 'data-option-value', 'data-title', 'data-name', 'data-variant-title', 'aria-label', 'title', 'value', 'class'];
    for (var i = 0; i < attrs.length; i += 1) {
      if (node.getAttribute) {
        var token = colorToken(node.getAttribute(attrs[i]));
        if (token) return token;
      }
    }
    return colorToken(node.textContent);
  }

  function getVariants(root) {
    try {
      var node = root.querySelector('[data-uc-bc-json="variants"]');
      return node ? JSON.parse(node.textContent || '[]') : [];
    } catch (error) {
      return [];
    }
  }

  function variantIdFromTitle(root, title) {
    var token = colorToken(title);
    if (PISTOL_BY_COLOR[token]) return PISTOL_BY_COLOR[token];

    var target = cleanText(title);
    var variants = getVariants(root);
    for (var i = 0; i < variants.length; i += 1) {
      var variantText = cleanText([variants[i].title, variants[i].public_title, variants[i].option1, variants[i].option2, variants[i].option3].join(' '));
      if (variantText === target || variantText.indexOf(target) !== -1 || target.indexOf(variantText) !== -1) {
        return Number(variants[i].id);
      }
    }

    return null;
  }

  function selectedCard(root, button) {
    return button.closest('.uc-bc-clean-card') ||
      root.querySelector('.uc-bc-clean-card.is-selected, .uc-bc-clean-card.is-active, .uc-bc-clean-card[aria-pressed="true"], .uc-bc-clean-card[aria-selected="true"]') ||
      root;
  }

  function desiredCount(root, button) {
    var card = selectedCard(root, button);
    var chipNames = card ? card.querySelectorAll('.uc-bc-clean-chip-name') : [];
    if (chipNames.length > 0) return chipNames.length;

    var tier = card && card.getAttribute('data-uc-bc-tier');
    if (tier === 'single') return 1;
    if (tier === 'two') return 2;

    var qtyNode = card && card.querySelector('.uc-bc-clean-stepper span');
    var qty = qtyNode ? parseInt(qtyNode.textContent, 10) : 0;
    if (qty >= 3) return qty;

    var text = cleanText((card && card.textContent) || button.textContent);
    if (/\bthree\b|\b3\b/.test(text)) return 3;
    if (/\btwo\b|\b2\b/.test(text)) return 2;
    return 1;
  }

  function idsFromVisibleChips(root, button, desired) {
    var card = selectedCard(root, button);
    var ids = [];
    var chips = card.querySelectorAll('.uc-bc-clean-chip-name');
    chips.forEach(function (chip) {
      if (ids.length >= desired) return;
      var id = variantIdFromTitle(root, chip.textContent);
      if (id) ids.push(id);
    });
    return ids;
  }

  function idsFromSelectedControls(root, desired) {
    var ids = [];
    var nodes = root.querySelectorAll('select, input:checked, .is-selected, .selected, .active, .is-active, [aria-pressed="true"], [aria-selected="true"]');
    nodes.forEach(function (node) {
      if (ids.length >= desired) return;
      if (node.tagName === 'SELECT' && node.selectedOptions) {
        Array.prototype.forEach.call(node.selectedOptions, function (option) {
          if (ids.length >= desired) return;
          var id = PISTOL_BY_COLOR[colorFromNode(option)] || PISTOL_BY_COLOR[colorFromNode(node)];
          if (id) ids.push(id);
        });
        return;
      }
      var id = PISTOL_BY_COLOR[colorFromNode(node)];
      if (id) ids.push(id);
    });
    return ids;
  }

  function bundleItems(root, button) {
    var desired = desiredCount(root, button);
    var selectedChipNames = selectedCard(root, button).querySelectorAll('.uc-bc-clean-chip-name');
    var ids = idsFromVisibleChips(root, button, desired);
    if (selectedChipNames.length > 0 && ids.length < selectedChipNames.length) return null;

    if (ids.length < desired) {
      idsFromSelectedControls(root, desired).forEach(function (id) {
        if (ids.length < desired) ids.push(id);
      });
    }
    if (ids.length < desired) return null;

    var qtyById = {};
    ids.slice(0, desired).forEach(function (id) {
      qtyById[id] = (qtyById[id] || 0) + 1;
    });
    return Object.keys(qtyById).map(function (id) {
      return { id: Number(id), quantity: qtyById[id] };
    });
  }

  function cartAdd(items) {
    return fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      if (!response.ok) throw new Error('Bundle add failed.');
      return response.json();
    });
  }

  function openDrawer() {
    if (typeof window.openCartDrawer === 'function') {
      return window.openCartDrawer();
    }
    document.dispatchEvent(new CustomEvent('uc:cart:open'));
    document.body.classList.add('cart-sidebar-show');
    var drawer = document.querySelector('#halo-cart-sidebar');
    if (drawer) drawer.setAttribute('aria-hidden', 'false');
    return Promise.resolve();
  }

  function handleBundleAdd(button, event) {
    var root = button.closest('[data-uc-bc-clean]');
    if (!root) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    if (button.dataset.ucBundleBusy === 'true') return;

    var items = bundleItems(root, button);
    if (!items || !items.length) {
      button.textContent = 'Pick colors first';
      window.setTimeout(function () { button.textContent = button.getAttribute('aria-label') || button.value || 'Add to cart'; }, 1200);
      return;
    }

    var originalText = button.textContent;
    button.dataset.ucBundleBusy = 'true';
    button.textContent = 'Adding...';
    cartAdd(items).then(function () {
      return openDrawer();
    }).then(function () {
      button.textContent = 'Added';
    }).catch(function (error) {
      console.error(error);
      button.textContent = 'Try again';
    }).finally(function () {
      window.setTimeout(function () {
        button.dataset.ucBundleBusy = 'false';
        button.textContent = originalText;
      }, 800);
    });
  }

  window.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.uc-bc-clean-add');
    if (button) handleBundleAdd(button, event);
  }, true);
})();
